module.exports = __webpack_public_path__ + "static/media/26.84f406f0.jpg";